import { L10nTranslationService } from 'angular-l10n';

/** "30 seconds", "minute", "5 minutes": reads after "every" */
export function describeInterval(seconds: number, translation: L10nTranslationService): string {
  if (seconds % 60 !== 0) {
    return translation.translate('Dashboard.Interval.Seconds', { count: seconds });
  }
  const minutes = seconds / 60;
  return minutes === 1
    ? translation.translate('Dashboard.Interval.Minute')
    : translation.translate('Dashboard.Interval.Minutes', { count: minutes });
}
